import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const GetConfigNames = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/config-names`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load config names.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const CreateConfigName = async (
  payload: any,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/config-names/create`, payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to create config name.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const UpdateConfigName = async (
  payload: any,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/config-names/update`, payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to update config name.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const DeleteConfigName = async (
  id: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/config-names/delete`, { id });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to delete config name.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};
